<ion-content class="container" id="elcm">
  <!-- 
  <ion-row *ngIf="!statusFlag && router.url.includes('Setup')">
    <div style="color: red; padding: 20px; font-weight: 500;">
      ⚠️ Not Completed Setup
    </div>
  </ion-row>
  <ion-row *ngIf="!getStatusFlag && !router.url.includes('Setup') && selectedTypeTabName !== 'Probation'">
    <div style="color: red; padding: 20px; font-weight: 500;">
      ⚠️ Not Completed Setup
    </div>
  </ion-row>
    <ion-row *ngIf="checkanydaysEmpty && router.url.includes('Setup')">
    <div style="color: red; padding: 20px; font-weight: 500;">
      ⚠️ Not Completed Setup
    </div>
  </ion-row>

   <ion-row *ngIf="flag && !router.url.includes('Setup') && selectedTypeTabName !== 'Probation'">
    <div style="color: red; padding: 20px; font-weight: 500;">
      ⚠️ Not Completed Setup 22
    </div>
  </ion-row> -->

<ion-row *ngIf="
   selectedTypeTabNameForSetUp!=='exitsetup'&& loggedInUserRole!=='Employee'&&(
      (!statusFlag && router.url.includes('Setup')) ||
      (checkanydaysEmpty && router.url.includes('Setup')) ||
      (!getStatusFlag && !router.url.includes('Setup') && selectedTypeTabName !== 'Probation') ||
      (!getStatusFlag && !router.url.includes('Setup') && selectedTypeTabName?.trim().toLowerCase() !== 'probation') ||
      (flag && !router.url.includes('Setup') && selectedTypeTabName !== 'Probation')
    )
  ">

    <div style="color: red; padding: 20px; font-weight: 500;">
      ⚠️ Not Completed Setup
    </div>
  </ion-row>
  <ion-row size="12" *ngIf="selectedTypeTabNameForSetUp=='exitsetup' && selectedTypeTabName!=='Probation' && selectedTypeTabName!=='Reports'
         ||(selectedTypeTabNameForSetUp=='offerAndAppoinment'&& loggedInUserRole=='Employee')">
    <div
      *ngIf="checkExitsetupcompletedornot?.length>0 ||selectedOptionForExit==null ||selectedOptionForExit=='' ||checkExitsetupcompletedornot"
      style="color: red;padding: 20px 20px 0px 20px;">
      ⚠️ Not Completed Setup
    </div>
  </ion-row>
  
  <div class="tabs-container">

    <div class="card">
      <ion-row *ngIf="!router.url.includes('Setup')">
        <ion-col size="12" size-md="9" class="pl-15 pr-0 pb-0">
          <div class="borderbottomForTab" *ngIf="!router.url.includes('Setup') ">

            <ng-container *ngIf="
            (loggedInUserRole === 'Manager' && selectedOptionForConfirmation === 'HOD') ||
            (loggedInUserRole === 'HOD' && selectedOptionForConfirmation === 'LINE_MANAGER')&&
            ((checkLineManagerAndHod?.length || 0) === 0 && (checkLineManagerAndHodForConfirm?.length || 0) === 0)||loggedInUserRole=='Employee'
          ">
              <div
                *ngIf="!(loggedInUserRole == 'HR Admin'|| loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' ||loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')">
                <mat-tab-group #tabGroup class="pt-10 pr-10" [selectedIndex]="selectedTypeTabIndex"
                  (selectedTabChange)="tabTypeChanged($event)">
                  <mat-tab label="Dashboard"
                    *ngIf="loggedInUserRole!='Employee' &&!(loggedInUserRole=='Manager'&&selectedOptionForConfirmation === 'HOD'&& selectedOptionForExit=='HOD_AND_HR')">
                    <ng-template mat-tab-label>
                      <span style="display: contents;">
                        <span class="material-icons mr-10">speed</span>Dashboard
                      </span>
                    </ng-template>
                  </mat-tab>
                  <mat-tab label="ProbationforEmployee" *ngIf="checkProbationEmployee">
                    <ng-template mat-tab-label>
                      <span style="display: contents;">
                        <span class="material-icons mr-10">group</span>
                        Probation
                      </span>
                    </ng-template>
                  </mat-tab>

                  <mat-tab label="exit">
                    <ng-template mat-tab-label>
                      <span style="display: contents;">
                        <span class="material-icons mr-10">
                          group
                        </span>Exit</span>
                    </ng-template>
                  </mat-tab>
                  <mat-tab label="Reports">
                    <ng-template mat-tab-label>
                      <span style="display: contents;">
                        <span class="material-icons mr-10">description</span>
                        Reports
                      </span>
                    </ng-template>
                  </mat-tab>
                </mat-tab-group>
              </div>
            </ng-container>

            <ng-container *ngIf="(loggedInUserRole == 'Manager' && selectedOptionForConfirmation == 'LINE_MANAGER') || 
            (loggedInUserRole == 'HOD' && selectedOptionForConfirmation == 'HOD')">
              <mat-tab-group #tabGroup class="pt-10 pr-10" [selectedIndex]="selectedTypeTabIndex"
                (selectedTabChange)="tabTypeChanged($event)">
                <mat-tab label="Dashboard">
                  <ng-template mat-tab-label>
                    <span style="display: contents;">
                      <span class="material-icons mr-10">speed</span>Dashboard
                    </span>
                  </ng-template>
                </mat-tab>

                <mat-tab label="Probation">
                  <ng-template mat-tab-label>
                    <span style="display: contents;">
                      <span class="material-icons mr-10">group</span>Probation
                    </span>
                  </ng-template>
                </mat-tab>
                <mat-tab label="exit">
                  <ng-template mat-tab-label>
                    <span style="display: contents;">
                      <span class="material-icons mr-10">
                        group
                      </span>Exit</span>
                  </ng-template>
                </mat-tab>
                <mat-tab label="Reports">
                  <ng-template mat-tab-label>
                    <span style="display: contents;">
                      <span class="material-icons mr-10">description</span>Reports
                    </span>
                  </ng-template>
                </mat-tab>
              </mat-tab-group>
            </ng-container>
            <!-- ------------------------------------------------------------------------------------------------------------------------------------------- -->

            <ng-container
              *ngIf="(loggedInUserRole == 'HOD' && selectedOptionForConfirmation == 'LINE_MANAGER' && (checkLineManagerAndHod?.length>0 ||checkLineManagerAndHodForConfirm?.length>0))">
              <mat-tab-group #tabGroup class="pt-10 pr-10" [selectedIndex]="selectedTypeTabIndex"
                (selectedTabChange)="tabTypeChanged($event)">
                <mat-tab label="Dashboard">
                  <ng-template mat-tab-label>
                    <span style="display: contents;">
                      <span class="material-icons mr-10">speed</span>Dashboard
                    </span>
                  </ng-template>
                </mat-tab>

                <mat-tab label="Probation">
                  <ng-template mat-tab-label>
                    <span style="display: contents;">
                      <span class="material-icons mr-10">group</span>Probation
                    </span>
                  </ng-template>
                </mat-tab>
                <mat-tab label="exit">
                  <ng-template mat-tab-label>
                    <span style="display: contents;">
                      <span class="material-icons mr-10">
                        group
                      </span>Exit</span>
                  </ng-template>
                </mat-tab>
                <mat-tab label="Reports">
                  <ng-template mat-tab-label>
                    <span style="display: contents;">
                      <span class="material-icons mr-10">description</span>Reports
                    </span>
                  </ng-template>
                </mat-tab>
              </mat-tab-group>
            </ng-container>
            <!-- ------------------------------------------------------------------------------------------------------------------------------------------- -->

            <span
              *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' ||loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD'">
              <mat-tab-group #tabGroup class="pt-10 pr-10" [selectedIndex]="selectedTypeTabIndex"
                (selectedTabChange)="tabTypeChanged($event)">

                <mat-tab label="Dashboard">
                  <ng-template mat-tab-label>
                    <span style="display: contents;">
                      <span class="material-icons mr-10">
                        speed
                      </span>Dashboard</span>
                  </ng-template>
                </mat-tab>

                <!-- </span> -->
                <mat-tab label="OfferAndAppointment">
                  <ng-template mat-tab-label>
                    <span style="display: contents;">
                      <span class="material-icons mr-10">
                        group
                      </span>Offer And Appointment</span>
                  </ng-template>
                </mat-tab>

                <mat-tab label="Probation">
                  <ng-template mat-tab-label>
                    <span style="display: contents;">
                      <span class="material-icons mr-10">
                        group
                      </span>Probation</span>
                  </ng-template>
                </mat-tab>

                <mat-tab label="exit">
                  <ng-template mat-tab-label>
                    <span style="display: contents;">
                      <span class="material-icons mr-10">
                        group
                      </span>Exit</span>
                  </ng-template>
                </mat-tab>
                <mat-tab label="Reports">
                  <ng-template mat-tab-label>
                    <span style="display: contents;">
                      <span class="material-icons mr-10">
                        description
                      </span>Reports</span>
                  </ng-template>
                </mat-tab>
              </mat-tab-group>
            </span>


          </div>
        </ion-col>
        <ion-col size="12" size-md="3" class="borderbottomForTab pl-10 pt-10 pr-10"
          *ngIf="!router.url.includes('Setup') && (loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD') && !mobileResponsiveService.hideForTabletAndBelow">
          <div class="center-content float-right">
            <div>
              <!-- (click)="onClickLogs('Logs')" -->
              <span class="cp fs-14 fs_12ForMobile link font_regular center-content mr-20"
                (click)="onClickLogs('elcm')">
                <img src="././assets/icon/logsIcon.svg"><u>Logs</u></span>
            </div>
            <div>
              <button type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content mr-5"
                [style.background-color]="buttonColorName" (click)="onClickSetup('Setup')">
                <span class="material-icons fs-20 mr-5">settings</span>Setup</button>

            </div>

            <!----------------------------------------- End Setup-------------------------- -->


          </div>
        </ion-col>
      </ion-row>
      <!-- {{letterheadFilleFromBackendSide}}
      <ion-row size="12" *ngIf="selectedTypeTabName!=='Probation' && selectedTypeTabNameForSetUp !=='exitsetup'
      && !(selectedTypeTabNameForSetUp=='offerAndAppoinment'&& loggedInUserRole=='Employee')||selectedTypeTabName == 'Dashboard'">
        <div *ngIf="(checkanydaysEmpty || !selectedOptionSalaryBreakUp||!selectedOptionForAppoinmentLetter|| !selectedcodecreateOption || !letterheadFilleFromBackendSide||!noOfDaysConfirmation 
          || !selectedOptionForConfirmation)" style="color: red;padding: 20px 20px 0px 20px;">
          Not Completed Setup
        </div>
      </ion-row> -->



    </div>

    <!---Setup Popup --->
    <div class="modal fade" [style.display]="showSetupPopup ? 'block' : 'none'"
      *ngIf="!mobileResponsiveService.hideForTabletAndBelow">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="mt-10 d-flex pt-5 pb-10 pr-10 pl-0 headerBreadcrumb" (click)="onClickback()">
            <img src="././assets/icon/backArrow.svg" class="cp">
            <label class="font_semibold fs-18 fs_16ForMobile ml-10 mt-5 black_color">
              <span class="cp">ELCM</span> /
              <span [style.color]="buttonColorName">Setup</span>
            </label>
          </div>

          <!-- ------------------------------------Set Up Tab      ------------------------- -->
          <!-- <div class="card">
            <ion-row>
              <ion-col size-sm="10" size-md="9" size-lg="9" size-xs="10" class="pl-15 pr-0 pb-0">
                <div class="borderbottomForTab"  >
                  <mat-tab-group #tabGroup class="pt-10 pr-10" [selectedIndex]="selectedTypeTabIndex"
                    (selectedTabChange)="tabTypeChanged($event)">
                   
                    <mat-tab label="Dashboard">
                      <ng-template mat-tab-label>
                        <span style="display: contents;">
                          <span class="material-icons mr-10">
                            speed
                          </span>Dashboard</span>
                      </ng-template>
      
      
                    </mat-tab>
                    <mat-tab label="OfferAndAppointment">
                      <ng-template mat-tab-label>
                        <span style="display: contents;">
                          <span class="material-icons mr-10">
                            group
                          </span>ELCM Master</span>
                      </ng-template>
                    </mat-tab>
                    <mat-tab label="Reports">
                      <ng-template mat-tab-label>
                        <span style="display: contents;">
                          <span class="material-icons mr-10">
                            description
                          </span>Reports</span>
                      </ng-template>
                    </mat-tab>
                  </mat-tab-group>
                </div>
              </ion-col>
             
            </ion-row>
      
          </div> -->
          <!-- ------------------------------------Set Up Tab      ------------------------- -->

          <div class="borderbottomForTab ml-20">
            <mat-tab-group #tabGroup class="pt-10 pr-10" [selectedIndex]="selectedTypeTabIndex"
              (selectedTabChange)="setuptabTypeChanged($event)">
              <!-- *ngIf= "!(loggedInUserRole == 'Employee')|| findLogdinUserAsaAuthority" -->
              <mat-tab label="offerAndAppoinment">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      speed
                    </span>Offer And Appointment</span>
                </ng-template>


              </mat-tab>
              <mat-tab label="ProbationandConfirm">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      group
                    </span>Probation And Confirmation</span>
                </ng-template>
              </mat-tab>
              <mat-tab label="exitsetup">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      description
                    </span>Exit</span>
                </ng-template>
              </mat-tab>
            </mat-tab-group>
          </div>

          <div class="modal-body p-20">
            <ion-row style="margin-bottom: 10px;">

              <!-- <div
                *ngIf="hasInvalidCode || !selectedOptionSalaryBreakUp || !selectedcodecreateOption || !letterheadFilleFromBackendSide"
                style="color: red;">
                Not Completed Set Up
              </div> -->

            </ion-row>
            <div class="cardBox mb-20">
              <div class="cardBoxHeading font_medium fs-14 fs_12ForMobile">
                <ion-row class="pl-5">
                  <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                    <div class="font_bold fs-14 fs_12ForMobile">Setup</div>
                  </ion-col>
                </ion-row>
              </div>

              <div class="p-10">




                <ion-row>
                  <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
                    <ion-row>
                      <!-- <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                        <div class="formLabelSemiBoldfs14 mb-5">Year <span class="red">*</span></div>
                        <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                          <mat-select placeholder="Select Year">
                            <mat-option value="FY2024-25">FY2024-25</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </ion-col> -->

                      <ion-col size="4">
                        <div class="formLabelRegularfs16 mb-5">
                          Fiscal Year<span class="red-cl">&nbsp;*</span>
                        </div>
                        <div class="inputBoxDisabled">
                          {{ sharedService.transform(loggedInCompanyFiscalyear) }}
                        </div>
                      </ion-col>
                      <ion-col size="4">
                        <div class="formLabelRegularfs16 mb-5">
                          Year<span class="red-cl">&nbsp;*</span>
                        </div>
                        <mat-form-field class="mat-height40 mat-input-style">
                          <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency"
                            (selectionChange)="getYearSetup($event)">
                            <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                              {{sharedService.transformYearToFyFormat(item.year)}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </ion-col>

                    </ion-row>
                  </ion-col>
                </ion-row>
              </div>
            </div>
            <!-- ------------------------------------------------------------------- offer And Appoinment ----------------------------------------------------->
            <div *ngIf="selectedTypeTabNameForSetUp=='offerAndAppoinment'">


              <div class="cardBox mb-20 probation">


                <div class="card">
                  <div class="table-container">
                    <ion-row class="p-5 mt-5">
                      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">

                        <table class="custom-table mat-elevation-z1 tableAccrossYear">
                          <tr>
                            <th>Band</th>
                            <th>Grade</th>
                            <th>Probation Periods</th>

                            <!-- <th>Actions</th> -->
                          </tr>
                          <ng-container *ngFor="let item of probstionPriodsData; let i = index">
                            <tr *ngFor="let gradeItem of item.grades; let j = index">
                              <td *ngIf="j === 0" [attr.rowspan]="item.grades.length">{{ item.band }}</td>
                              <td>{{ gradeItem.grade }}</td>
                              <!-- <td>
                                <mat-form-field class="w-90 mat-height40 mat-input-style">
                                  <mat-select [(ngModel)]="gradeItem.probationPeriod"
                                    placeholder="Select probation periods" class="color-black"
                                    (ngModelChange)="addprobationPeriods(item, gradeItem)"
                                    [disabled]="(editableIndex !== i || editableSubIndex !== j)">
                                    <mat-option [value]="3">3</mat-option>
                                    <mat-option [value]="6">6</mat-option>
                                    <mat-option [value]="9">9</mat-option>
                                    <mat-option [value]="12">12</mat-option>
                                  </mat-select>
                                </mat-form-field>

                              </td> -->

                              <td>
                                <mat-radio-group class="custom-radio-group" [(ngModel)]="gradeItem.probationPeriod"
                                  (ngModelChange)="addprobationPeriods(item,gradeItem)">
                                  <mat-radio-button *ngFor="let option of probationOptions" class="custom-radio"
                                    [value]="option">

                                    <span class="radio-label" [ngStyle]="{
                                      'color': gradeItem.probationPeriod==option  ? 'white' : 'black',}">
                                      {{ option }}
                                    </span>
                                  </mat-radio-button>

                                </mat-radio-group>



                              </td>
                              <!-- <td>
                                <div class="d-flex" class="addProbation">
                                
                                  <img (click)="onClickEdit(i, j)"
                                    *ngIf="(editableIndex !== i || editableSubIndex !== j)" class="ml-5 cp imgEdit"
                                    title="Edit" src="./assets/icon/edit.png" />
                           
                                  <span (click)="onClickClose()" *ngIf="editableIndex === i && editableSubIndex === j"
                                    class="material-icons close p-10 cp fs-20">close</span>

                                 
                                  <span *ngIf="editableIndex === i && editableSubIndex === j"
                                    class="addProbation material-icons link p-10 cp fs-20" [class.disabled]="loading"
                                    (click)="saveprobationPeriods()">
                                    check
                                  </span>
                                </div>
                              </td> -->
                            </tr>
                          </ng-container>
                        </table>




                      </ion-col>
                    </ion-row>
                  </div>



                </div>



              </div>

              <div class="cardBox mb-20">
                <div class="cardBoxHeading font_medium fs-14 fs_12ForMobile">
                  <ion-row class="pl-5">
                    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                      <div class="font_bold fs-14 fs_12ForMobile">Employee Code Creation Logic Setup <span
                          class="red-cl">&nbsp;*</span></div>
                    </ion-col>
                  </ion-row>
                </div>
                <!-- <div class="radio-group mt-10">
                <label>
                  <input type="radio" name="codeCreationLogic" [(ngModel)]="selectedcodecreateOption" value="auto" />
                  Employee code creation logic
                </label>
                <label>
                  <input type="radio" name="codeCreationLogic" [(ngModel)]="selectedcodecreateOption" value="manual" />
                  Manual code
                </label>
              </div> -->
                <ion-row>
                  <ion-col size="6">

                    <!-- <mat-radio-group [(ngModel)]="selectedcodecreateOption" aria-label="Select an option"
                      [disabled]="flagData.length > 0" class="fs-14 fs_12ForMobile font_semibold ml-15"
                      (change)="onSelectionChangeForWantLimit($event.value)">
                      <mat-radio-button value="auto">
                        Employee code creation logic
                      </mat-radio-button>
                      <mat-radio-button value="manual" class="pl-10">
                        Manual code
                      </mat-radio-button>
                    </mat-radio-group> -->
                    <mat-radio-group [(ngModel)]="selectedcodecreateOption"
                      (ngModelChange)="onSelectionChangeForWantLimit($event)" [disabled]="flagData.length > 0"
                      class="fs-14 fs_12ForMobile font_semibold ml-15">
                      <mat-radio-button value="auto">
                        Employee code creation logic
                      </mat-radio-button>
                      <mat-radio-button value="manual" class="pl-10">
                        Manual code
                      </mat-radio-button>
                    </mat-radio-group>

                    <ion-col *ngIf="selectedcodecreateOption=='auto'">
                      <div class="formLabelSemiBoldfs14 mb-5 ml-25 mt-10">
                        Select Department/Location
                      </div>

                      <mat-form-field class="mat-height40 mat-input-style ml-20 mb-10">
                        <mat-select placeholder="Select" [(ngModel)]="selectedDeptLocation"
                          [disabled]="flagData.length > 0" class="color-black">
                          <mat-option [value]="'DEPARTMENT'">
                            Department
                          </mat-option>
                          <mat-option [value]="'LOCATION'">
                            Location
                          </mat-option>
                          <mat-option [value]="'BOTH'">
                            Both(Dept/Loc)
                          </mat-option>
                          <mat-option [value]="'none'">
                            None
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ion-col>

                  </ion-col>
                  <!-- <ion-col size="6" class="float-right" *ngIf="selectedcodecreateOption=='auto'">

                    <div class="d-flex justify-content-flex-end ">
                      <div style="margin-right: 15px; font-size: 12px;">
                        <label style="color: red;">Code Creation Suggestions</label>
                        <p>Only Prefix and Limit: <strong>{{ generateCode('PHI', '003') }}</strong></p>
                        <p>Only Prefix, Limit, and Dept: <strong>{{ generateCode('PHI','HR','003') }}</strong></p>
                        <p>Only Prefix, Limit, and Location: <strong>{{ generateCode('PHI', '003', '', 'PUN')
                            }}</strong>
                        </p>
                        <p>Prefix, Limit, Location & Dept: <strong>{{ generateCode('PHI','HR', '003', 'PUN') }}</strong>
                        </p>
                      </div>
                    </div>
                  </ion-col> -->

                </ion-row>

                <div class="formLabelSemiBoldfs14 ml-20" *ngIf="selectedcodecreateOption=='auto'">
                  <span class="ml-10">Code Format</span>
                  <!-- <mat-icon class="info-icon">info</mat-icon> -->
                  <mat-icon class="info-icon" matTooltip="Code Creation Suggestions

                Only Prefix and Limit: PHI003
                
                Only Prefix, Limit, and Dept: PHIHR003
                
                Only Prefix, Limit, and Location: PHI003PUN
                
                Prefix, Limit, Location & Dept: PHIHR003PUN" matTooltipPosition="above"
                    matTooltipClass="custom-tooltip">
                    info
                  </mat-icon>

                </div>
                <ion-row class="m-10" style="padding: 10px 20px 20px 20px;" *ngIf="selectedcodecreateOption=='auto'">

                  <ion-col size="3">
                    <label>Prefix<span class="red-cl">&nbsp;*</span></label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style">
                      <input matInput placeholder="Prefix" [(ngModel)]="setPrefix" maxlength="255" />

                    </mat-form-field>
                  </ion-col>
                  <ion-col size="3">


                    <label>Set Limit<span class="red-cl">&nbsp;*</span></label>

                    <mat-form-field class="w-100 mat-height40 mat-input-style">
                      <input type="text" matInput placeholder="Set Limit" [(ngModel)]="setLimit" [readonly]="updateFlag"
                        maxlength="255" inputmode="numeric" (keypress)="allowOnlyDigits($event)" />
                      <mat-error *ngIf="setLimit?.length > 255">
                        Maximum 255 digits allowed.
                      </mat-error>
                    </mat-form-field>

                  </ion-col>


                  <ion-col size="6" class="d-flex phi-gap-10 mt-25">
                    <button class="nineBox_Btn fs-14 fs_12ForMobile add_btn center-content "
                      [style.background-color]="buttonColorName" (click)="saveData()"
                      style="margin-right: 10px;">{{updateFlag?'Update':'Save'}}</button>
                    <button class="nineBox_Btn fs-14 fs_12ForMobile center-content "
                      [style.background-color]="buttonColorName" (click)="addDeptAndLoc('addDept')"
                      style="margin-right: 10px;"
                      *ngIf="selectedDeptLocation === 'DEPARTMENT' || selectedDeptLocation === 'BOTH'"
                      [ngClass]="{'disabled-opacity': getEmployeeCodeDataList?.length === 0}">Add Dept</button>
                    <button class="nineBox_Btn fs-14 fs_12ForMobile center-content locationDisabled "
                      [style.background-color]="buttonColorName" (click)="addDeptAndLoc('addLoc')"
                      *ngIf="selectedDeptLocation === 'LOCATION' || selectedDeptLocation === 'BOTH'"
                      [ngClass]="{'disabled-opacity': getEmployeeCodeDataList?.length === 0}">Add
                      Location</button>

                  </ion-col>

                  <!-- <ion-col size="3">
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Select Date" />

                  </mat-form-field>
                </ion-col>
                <ion-col size="3">
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Select Date" />

                  </mat-form-field>
                </ion-col> -->
                </ion-row>

              </div>
              <!-- <div class="cardBox mb-20">
                <div class="cardBoxHeading font_medium fs-14 fs_12ForMobile">
                  <ion-row class="pl-5">
                    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                  
                      <div class="font_bold fs-14 fs_12ForMobile">Salary BreakUp <span class="red-cl">&nbsp;*</span></div>
                    </ion-col>
                  </ion-row>
                </div>
                <div class="p-10">

                  <div style="padding: 0px 8px 8px 8px;">
                    <ion-row>
                      <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
                        <div class="font_bold fs-14 fs_12ForMobile ">Salary BreakUp Annexure Needed With Offer Letter ?</div>
                      </ion-col>
                      <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
                        <div class="font_bold fs-14 fs_12ForMobile">Direct Appointment Letter Process ?</div>
                      </ion-col>
                    </ion-row>
                    <ion-row>
                      <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
                        <mat-radio-group [(ngModel)]="selectedOptionSalaryBreakUp" aria-label="Select an option"
                          class="fs-14 fs_12ForMobile font_semibold" (change)="onSelectionChangesalaryAndAppoinment($event.value)">
                          <mat-radio-button value="Yes">
                            Yes
                          </mat-radio-button>
                          <mat-radio-button value="NO" class="pl-10">
                            No
                          </mat-radio-button>
                        </mat-radio-group>
                      </ion-col>
                      <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
                        <mat-radio-group [(ngModel)]="selectedOptionForAppoinmentLetter" aria-label="Select an option"
                          class="fs-14 fs_12ForMobile font_semibold" (change)="onSelectionChangeAppoinment($event.value)">
                          <mat-radio-button value="Yes">
                            Yes
                          </mat-radio-button>
                          <mat-radio-button value="NO" class="pl-10">
                            No
                          </mat-radio-button>
                        </mat-radio-group>
                      </ion-col>
                    </ion-row>


                  </div>





                </div>

              </div> -->


              <div class="cardBox mb-20">
                <div class="cardBoxHeading font_medium fs-14 fs_12ForMobile">
                  <ion-row class="pl-5">
                    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                      <!-- <div class="font_bold fs-14 fs_12ForMobile">Offer letter upload set up </div> -->
                      <div class="font_bold fs-14 fs_12ForMobile">Salary BreakUp <span class="red-cl">&nbsp;*</span>
                      </div>
                    </ion-col>
                  </ion-row>
                </div>
                <div class="p-10">

                  <div style="padding: 0px 8px 8px 8px;">
                    <ion-row>
                      <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
                        <div class="font_bold fs-14 fs_12ForMobile ">Salary BreakUp Annexure Needed With Offer Letter ?
                        </div>
                      </ion-col>
                      <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
                        <div class="font_bold fs-14 fs_12ForMobile">Direct Appointment Letter Process ?</div>
                      </ion-col>
                    </ion-row>
                    <ion-row>
                      <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
                        <mat-radio-group [(ngModel)]="selectedOptionSalaryBreakUp" aria-label="Select an option"
                          class="fs-14 fs_12ForMobile font_semibold">
                          <mat-radio-button value="Yes" (click)="onSelectionChangesalaryAndAppoinment('Yes', $event)">
                            Yes </mat-radio-button>
                          <mat-radio-button value="No" (click)="onSelectionChangesalaryAndAppoinment('No', $event)"> No
                          </mat-radio-button>
                        </mat-radio-group>

                      </ion-col>
                      <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
                        <mat-radio-group [(ngModel)]="selectedOptionForAppoinmentLetter" aria-label="Select an option"
                          class="fs-14 fs_12ForMobile font_semibold">
                          <mat-radio-button value="Yes" (click)="onSelectionChangeAppoinment('Yes', $event)"> Yes
                          </mat-radio-button>
                          <mat-radio-button value="No" (click)="onSelectionChangeAppoinment('No', $event)"> No
                          </mat-radio-button>
                        </mat-radio-group>

                      </ion-col>
                    </ion-row>
                  </div>





                </div>

              </div>

              <div class="cardBox mb-20">
                <div class="cardBoxHeading font_medium fs-14 fs_12ForMobile">
                  <ion-row class="pl-5">
                    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                      <div class="font_bold fs-14 fs_12ForMobile">Create email set up </div>
                    </ion-col>
                  </ion-row>
                </div>
                <div class="p-10">
                  <ion-row>
                    <!--Employment application invite email set up   -->
                    <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                      <div class="fs-14 fs_12ForMobile font_semibold mt-20">Application Invite mail to Emp. </div>
                      <div class="content-box mt-20">
                        <div><img class="w50" src="././assets/icon/mail_Icon.svg" alt="createEmailBody"></div>
                        <button class="elcm_Btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                          (click)="onClickOpenCreateSurveyPopup('Create Email Body for Employment application')">+
                          Create</button>
                      </div>
                    </ion-col>
                    <!--Employment application invite email set up   -->
                    <!-- Intimation email from candidate set up -->
                    <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                      <div class="fs-14 fs_12ForMobile font_semibold mt-20">Intimation Mail to HR</div>
                      <div class="content-box mt-20">
                        <div><img class="w50" src="././assets/icon/mail_Icon.svg" alt="createEmailBody"></div>
                        <button class="elcm_Btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                          (click)="onClickOpenCreateSurveyPopup('Create Email Body for Intimation email')">+
                          Create</button>
                      </div>
                    </ion-col>
                    <!-- Intimation email from candidate set up -->
                    <!-- Offer letter upload set up -->
                    <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                      <div class="fs-14 fs_12ForMobile font_semibold mt-20">Offer letter mail</div>
                      <div class="content-box mt-20">
                        <div><img class="w50" src="././assets/icon/mail_Icon.svg" alt="createEmailBody"></div>
                        <button class="elcm_Btn fs-14 fs_12ForMobile"
                          [style.background-color]="selectedOptionForAppoinmentLetter === 'Yes' ? '#d3d3d3' : buttonColorName"
                          [style.opacity]="selectedOptionForAppoinmentLetter === 'Yes' ? '0.5' : '1'"
                          [disabled]="selectedOptionForAppoinmentLetter == 'Yes'"
                          (click)="onClickOpenCreateSurveyPopup('Create Email Body for offer letter email')">+
                          Create</button>
                      </div>
                    </ion-col>
                    <!-- Offer letter upload set up -->
                    <!-- Appoinment letter issuance email setup  -->
                    <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                      <div class="fs-14 fs_12ForMobile font_semibold mt-20">Appointment Letter Mail </div>
                      <div class="content-box mt-20">
                        <div><img class="w50" src="././assets/icon/mail_Icon.svg" alt="createEmailBody"></div>
                        <button class="elcm_Btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                          (click)="onClickOpenCreateSurveyPopup('Create Email Body for Appoinment letter issuance')">+
                          Create</button>
                      </div>
                    </ion-col>
                    <!-- Appoinment letter issuance email setup  -->
                  </ion-row>
                </div>
              </div>
              <!-- <div class="cardBox mb-20">
              <div class="cardBoxHeading font_medium fs-14 fs_12ForMobile">
                <ion-row class="pl-5">
                  <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                    <div class="font_bold fs-14 fs_12ForMobile">Intimation email from candidate set up </div>
                  </ion-col>
                </ion-row>
              </div>
              <div class="p-10">
                <ion-row>
                  <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                    <div class="fs-14 fs_12ForMobile font_semibold mt-20">Create Email Body</div>
                    <div class="content-box mt-20">
                      <div><img class="w50" src="././assets/icon/mail_Icon.svg" alt="createEmailBody"></div>
                      <button class="elcm_Btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                        (click)="onClickOpenCreateSurveyPopup('Create Email Body for Intimation email')">+
                        Create</button>
                    </div>
                  </ion-col>
                </ion-row>
              </div>
            </div> -->


              <!-- <div class="cardBox mb-20">
              <div class="cardBoxHeading font_medium fs-14 fs_12ForMobile">
                <ion-row class="pl-5">
                  <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                    <div class="font_bold fs-14 fs_12ForMobile">Appoinment letter issuance email setup </div>
                  </ion-col>
                </ion-row>
              </div>
              <div class="p-10">
                <ion-row>
                  <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                    <div class="fs-14 fs_12ForMobile font_semibold mt-20">Create Email Body</div>
                    <div class="content-box mt-20">
                      <div><img class="w50" src="././assets/icon/mail_Icon.svg" alt="createEmailBody"></div>
                      <button class="elcm_Btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                        (click)="onClickOpenCreateSurveyPopup('Create Email Body for Appoinment letter issuance')">+
                        Create</button>
                    </div>
                  </ion-col>
                </ion-row>
              </div>
            </div> -->
              <div class="cardBox mb-20">
                <div class="cardBoxHeading font_medium fs-14 fs_12ForMobile">
                  <ion-row class="pl-5">
                    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                      <div class="font_bold fs-14 fs_12ForMobile">Letter content </div>
                    </ion-col>
                  </ion-row>
                </div>
                <div class="p-10">
                  <ion-row>
                    <!-- <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                    <div class="content-box-upload mb-20 p-20">
                      <label>Appoinment letter </label>
                  
                      <div class="w-100 upload-box display-center mt-20 cp" [ngClass]="{'drag-over': isDragging}"
                        (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onFileDropped($event)"
                        *ngIf="!showBrowseBtn">
                        <div class="upload-file-container">
                          <p>Drag and drop a file here</p>
                          <p class="mt-5">OR</p>
                          <div *ngIf="!showBrowseBtn" class="w-100  display-center mt-20 cp"
                            (click)="browseImage.click()">
                            <button class="browse-btn" (click)="triggerFileInput('appoinmentLetter')">Browse</button>
                            <input #browseImage type="file" (change)="onFileSelected($event)" style="display:none;">
                          </div>
                        </div>
                        
                      </div>
                      <div *ngIf="showBrowseBtn" class="w-100 upload-box display-center mt-20 cp">
                        <div class="d-flex mb-20 mt-20">
                          <div class="verticle-center mr-20">
                            <img src="././assets/icon/successImport.svg">
                          </div>
                          <div class="flex-column">
                            <label class="fs-14 fs_12ForMobile font_medium text_gray1 mb-10">File Uploaded Successfully.</label>
                            <div class="d-flex">
                              <label class="fs-12 blue font_medium cl-black mx-width"
                                (click)="downloadFile('appointmentLetter')"
                                style="cursor: pointer; max-width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                                title="{{fileName}}">
                                {{fileName}}
                              </label>
                              <span class="removefile">
                                
                                <span class="material-icons close cp  imgRemove " title="Remove"
                                  (click)="onClickCancelUploadPolicy()">close</span>
                              </span>
                            </div>

                          </div>
                        </div>
                      </div>
                 
                      <div class="upload-file-validation d-flex">
                        <p style="color: red;"> Excel files are not allowed. </p>
                        <p style="margin-left: 10px;">One file only | 10 MB Limits </p>


                      </div>

                      <div class="btn-group">
                       
                        <button class="upload-policy-btn" [disabled]="isDisabledUploadPolicyBtn"
                          (click)="onClickUploadPolicy()">Upload Policy</button>
                      </div>
                    </div>
                  </ion-col> -->

                    <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                      <div class="fs-14 fs_12ForMobile font_semibold mt-20">Offer letter content</div>
                      <div class="content-box mt-20">
                        <div><img class="w70" src="././assets/icon/content-icon.jpg" alt="createEmailBody"></div>
                        <button class="elcm_Btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                          [style.background-color]="selectedOptionForAppoinmentLetter === 'Yes' ? '#d3d3d3' : buttonColorName"
                          [style.opacity]="selectedOptionForAppoinmentLetter === 'Yes' ? '0.5' : '1'"
                          [disabled]="selectedOptionForAppoinmentLetter == 'Yes'"
                          (click)="onClickOpenCreateSurveyPopup('Create offer letter content')">+
                          Create</button>
                      </div>
                    </ion-col>

                    <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                      <div class="fs-14 fs_12ForMobile font_semibold mt-20">Terms And Condition(optional)</div>
                      <div class="content-box mt-20">
                        <div><img class="w70" src="././assets/icon/content-icon.jpg" alt="createEmailBody"></div>
                        <button class="elcm_Btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                          [style.background-color]="selectedOptionForAppoinmentLetter === 'Yes' ? '#d3d3d3' : buttonColorName"
                          [style.opacity]="selectedOptionForAppoinmentLetter === 'Yes' ? '0.5' : '1'"
                          [disabled]="selectedOptionForAppoinmentLetter == 'Yes'"
                          (click)="onClickOpenCreateSurveyPopup('Add term And Condition')">+
                          Create</button>
                      </div>
                    </ion-col>
                    <!-- Offer letter upload set up -->
                    <!-- Appoinment letter issuance email setup  -->
                    <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                      <div class="fs-14 fs_12ForMobile font_semibold mt-20">Appointment Letter content </div>
                      <div class="content-box mt-20">
                        <div><img class="w70" src="././assets/icon/content-icon.jpg" alt="createEmailBody"></div>
                        <button class="elcm_Btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                          (click)="onClickOpenCreateSurveyPopup('Create Appoinment letter content')">+
                          Create</button>
                      </div>
                    </ion-col>

                    <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                      <div class="content-box-upload mb-20 p-20">

                        <label>Company Letterhead</label>

                        <div class="w-100 upload-box display-center mt-20 cp" id="fileInput"
                          [ngClass]="{'drag-over': isDraggingletterHead}" (dragover)="onDragOverletterHead($event)"
                          (dragleave)="onDragLeaveLetterHead($event)" (drop)="onFileDroppedLetterHead($event)"
                          *ngIf="!showletterHeadBrowseBtn">
                          <div class="upload-file-container">
                            <p>Drag and drop a file here</p>
                            <p class="mt-5">OR</p>
                            <div class="w-100 display-center mt-20 cp" (click)="browsecompanyletterheadImage.click()">
                              <button class="browse-btn">Browse</button>
                              <input #browsecompanyletterheadImage type="file" id="fileInput"
                                (change)="onFileSelectedForletterHead($event)" style="display:none;">
                            </div>
                          </div>
                        </div>

                        <!-- Uploaded File Section -->
                        <div *ngIf="showletterHeadBrowseBtn" class="w-100 upload-box display-center mt-20 cp">
                          <div class="d-flex mb-20 mt-20">
                            <div class="verticle-center mr-20">
                              <img src="././assets/icon/successImport.svg" style="width: 35px;margin-bottom: 14px;">
                            </div>
                            <div class="flex-column">
                              <label class="fs-14 fs_12ForMobile font_medium text_gray1 mb-10">File Uploaded
                                Successfully.</label>
                              <div class="d-flex">
                                <div class="d-flex">
                                  <label class="fs-12 blue font_medium cl-black mx-width"
                                    (click)="viewDocument(letterheadFilleFromBackendSide)"
                                    style="cursor: pointer; max-width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                                    title="{{ letterheadFilleFromBackendSide||'' }}">
                                    {{ letterheadFilleFromBackendSide }}
                                  </label>
                                  <span class="removefile">
                                    <span class="material-icons close cp imgRemove" title="Remove"
                                      (click)="onClickCancelUploadletterHead(letterheadFilleFromBackendSide,'letter')">close</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>


                        <div class="upload-file-validation d-flex">
                          <p style="color: red; margin-left: 10px;" *ngIf="!letterheadFilleFromBackendSide"> only A4
                            size pdf file allowed. </p>
                          <!-- <p style="margin-left: 10px;">One file only | 10 MB Limits </p> -->
                        </div>
                        <div class="btn-group">
                          <!-- <button class="Cancel-btn" (click)="onClickCancelUploadletterHead()">Cancel</button> -->
                          <button class="upload-policy-btn" [disabled]="isDisabledUploadPolicyBtn"
                            (click)="onClickUploadPolicy()">Upload</button>
                        </div>
                      </div>
                    </ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                      <div class="content-box-upload mb-20 p-20">

                        <label> Digital signature </label>
                        <div class="w-100 upload-box display-center mt-20 cp" [ngClass]="{'drag-over': isDraggingSign}"
                          (dragover)="onDragOverSing($event)" (dragleave)="onDragLeaveSign($event)"
                          (drop)="onFileDroppedSign($event)" *ngIf="!showSignBrowseBtn">
                          <div class="upload-file-container">
                            <p>Drag and drop a file here </p>
                            <p class="mt-5">OR</p>
                            <div *ngIf="!showSignBrowseBtn" class="w-100  display-center mt-20 cp"
                              (click)="browseSignImage.click()">
                              <button class="browse-btn" (click)="triggerFileInputSign()">Browse</button>
                              <input #browseSignImage type="file" (change)="onFileSelectedForSign($event,'sign')"
                                style="display:none;">
                            </div>
                          </div>

                        </div>
                        <div *ngIf="showSignBrowseBtn" class="w-100 upload-box display-center mt-20 cp">
                          <div class="d-flex mb-20 mt-20">
                            <div class="verticle-center mr-20">
                              <img src="././assets/icon/successImport.svg" style="width: 35px;margin-bottom: 14px;">
                            </div>
                            <div class="flex-column">
                              <label class="fs-14 fs_12ForMobile font_medium text_gray1 mb-10">File Uploaded
                                Successfully.</label>

                              <div class="d-flex">
                                <!-- <label class="fs-12 blue font_medium cl-black mx-width">{{signfileName}}</label> -->
                                <div class="d-flex">
                                  <label class="fs-12 blue font_medium cl-black mx-width"
                                    (click)="downloadSign(signfileNameForApiAppend)"
                                    style="cursor: pointer; max-width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                                    title="{{signfileNameForApiAppend}}">
                                    {{signfileNameForApiAppend.name ||signfileNameForApiAppend}}
                                  </label>
                                  <span class="removefile">

                                    <span class="material-icons close cp  imgRemove " title="Remove"
                                      (click)="onClickCancelUploadletterHead(signfileNameForApiAppend,'sign')">close</span>
                                  </span>
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="upload-file-validation d-flex" *ngIf="!showSignBrowseBtn">
                          <p style="color: red; margin-left: 10px;"> only image format allowed. </p>
                          <p style="margin-left: 10px;">One file only | 2 MB Limits </p>
                        </div>
                        <div class="btn-group">
                          <!-- <button class="Cancel-btn" (click)="onClickCancelUploadSign()">Cancel</button> -->
                          <button class="upload-policy-btn" [disabled]="isDisabledUploadPolicyBtnForSign"
                            (click)="onClickUploadSign()">Upload</button>
                        </div>
                      </div>
                    </ion-col>
                  </ion-row>
                </div>
              </div>




              <ion-row>
                <ion-col>
                  <div class="verticle-center" (click)="onClickback()">
                    <button class="nineBox_Btn_two fs-14 fs_12ForMobile center-content mt-20">Back</button>
                    <!-- <button class="nineBox_Btn fs-14 fs_12ForMobile center-content mt-20 ml-20"
                      [style.background-color]="buttonColorName">Save</button> -->
                  </div>
                </ion-col>
              </ion-row>
            </div>

            <!-- ------------------------------------------------------------------- probation and confirmation set up ----------------------------------------------------->
            <div *ngIf="selectedTypeTabNameForSetUp=='ProbationandConfirm' ">

              <div class="cardBox mb-20 probation">


                <div class="card">
                  <div class="table-container">
                    <ion-row class="p-5 mt-5">
                      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">

                        <table class="custom-table mat-elevation-z1 tableAccrossYear">
                          <tr>
                            <th>Band</th>
                            <th>Grade</th>
                            <th>Probation Period</th>
                            <th>Extension Periods In Months</th>
                            <!-- <th>Actions</th> -->
                          </tr>
                          <ng-container *ngFor="let item of probstionPriodsData; let i = index">
                            <tr *ngFor="let gradeItem of item.grades; let j = index">
                              <td *ngIf="j === 0" [attr.rowspan]="item.grades.length">{{ item.band }}</td>
                              <td>{{ gradeItem.grade }}</td>
                              <!-- <td>
                                <mat-form-field class="w-90 mat-height40 mat-input-style">
                                  <mat-select [(ngModel)]="gradeItem.probationPeriod"
                                    placeholder="select probation periods" class="color-black"
                                    (ngModelChange)="addprobationPeriods(item,gradeItem)" [disabled]="true">
                                    <mat-option [value]="3">3</mat-option>
                                    <mat-option [value]="6">6</mat-option>
                                    <mat-option [value]="9">9</mat-option>
                                    <mat-option [value]="12">12</mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </td> -->
                              <td>
                                <mat-radio-group class="custom-radio-group" [(ngModel)]="gradeItem.probationPeriod"
                                  (ngModelChange)="addprobationPeriods(item,gradeItem)">
                                  <mat-radio-button *ngFor="let option of probationOptions" class="custom-radio"
                                    [value]="option" [disableRipple]="true" [ngStyle]="{ 'pointer-events': 'none' }">

                                    <span class="radio-label" [ngStyle]="{
                                      'color': gradeItem.probationPeriod==option  ? 'white' : 'black',}">
                                      {{ option }}
                                    </span>
                                  </mat-radio-button>

                                </mat-radio-group>



                              </td>
                              <!-- <td>
                                
                                <mat-form-field class="w-90 mat-height40 mat-input-style">
                                  <mat-select [(ngModel)]="gradeItem.extensionPeriod"
                                    placeholder="select extension periods" class="color-black"
                                    (ngModelChange)="addprobationPeriods(item,gradeItem)"
                                    [disabled]="(editableIndex !== i || editableSubIndex !== j) ">
                                    <mat-option [value]="0">0</mat-option>
                                    <mat-option [value]="1">1</mat-option>
                                    <mat-option [value]="2">2</mat-option>
                                    <mat-option [value]="3">3</mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </td> -->
                              <td>
                                <mat-radio-group class="custom-radio-group" [(ngModel)]="gradeItem.extensionPeriod"
                                  (ngModelChange)="addprobationPeriods(item,gradeItem)">
                                  <mat-radio-button *ngFor="let option of probationOption1" class="custom-radio"
                                    [value]="option">

                                    <span class="radio-label" [ngStyle]="{
                                      'color': gradeItem.extensionPeriod==option  ? 'white' : 'black',}">
                                      {{ option }}
                                    </span>
                                  </mat-radio-button>

                                </mat-radio-group>



                              </td>
                              <!-- <td>

                                <div class="d-flex">
                              
                                  <img (click)="onClickEdit(i, j)"
                                    *ngIf="(editableIndex !== i || editableSubIndex !== j)" class="ml-5 cp imgEdit"
                                    title="Edit" src="./assets/icon/edit.png" />

                                  
                                  <span (click)="onClickClose()" *ngIf="editableIndex === i && editableSubIndex === j"
                                    class="material-icons close p-10 cp fs-20">close</span>

                               
                                  <span *ngIf="editableIndex === i && editableSubIndex === j"
                                    (click)="saveprobationPeriods()"
                                    class="material-icons link p-10 cp fs-20">check</span>
                                </div>

                              </td> -->
                            </tr>
                          </ng-container>
                        </table>





                      </ion-col>
                    </ion-row>
                  </div>



                </div>



              </div>
              <div class="cardBox mb-20">
                <div class="cardBoxHeading font_medium fs-14 fs_12ForMobile">
                  <ion-row class="pl-5">
                    <ion-col size="6">
                      <!-- <div class="font_bold fs-14 fs_12ForMobile">Offer letter upload set up </div> -->
                      <div class="font_bold fs-14 fs_12ForMobile">Confirmation/probation extention intimation email to
                        whom setup<span class="red-cl">&nbsp;*</span></div>
                    </ion-col>
                    <ion-col size="6">

                      <!-- <div class="font_bold fs-14 fs_12ForMobile">Point To Be Evaluated<span class="red-cl">&nbsp;*</span></div> -->
                    </ion-col>
                  </ion-row>
                </div>
                <div class="p-10">

                  <div style="padding: 0px 8px 8px 8px;">

                    <ion-row>
                      <ion-col size="6">
                        <mat-radio-group [(ngModel)]="selectedOptionForConfirmation" aria-label="Select an option"
                          class="fs-14 fs_12ForMobile font_semibold"
                          (change)="onSelectionChangeConfirmation($event.value)"
                          [disabled]="getconfirmationdata.length > 0">
                          <mat-radio-button value="HOD">
                            HOD
                          </mat-radio-button>
                          <mat-radio-button value="LINE_MANAGER" class="pl-10">
                            Line Manager
                          </mat-radio-button>
                        </mat-radio-group>
                      </ion-col>
                      <ion-col size="6" class="d-flex" style="gap: 10px;">

                        <button class="elcm_Btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                          (click)="addPerformanceRatingStandard('view')">View</button>
                        <button class="elcm_Btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                          (click)="addPerformanceRatingStandard('add')">+
                          Rating Standards</button>
                      </ion-col>


                    </ion-row>


                  </div>





                </div>

              </div>

              <div class="cardBox mb-20">
                <div class="cardBoxHeading font_medium fs-14 fs_12ForMobile">
                  <ion-row class="pl-5">
                    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                      <!-- <div class="font_bold fs-14 fs_12ForMobile">Offer letter upload set up </div> -->
                      <div class="font_bold fs-14 fs_12ForMobile">Confirmation/probation extention intimation mail
                        period set up<span class="red-cl">&nbsp;*</span></div>
                    </ion-col>
                  </ion-row>
                </div>
                <div class="p-10">

                  <div style="padding: 0px 8px 8px 8px;">

                    <ion-row>
                      <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4" class="mt-10">
                        <div class="formLabelRegularfs14 mb-5" size="3">No.of days before due date of confirmation</div>
                        <mat-form-field class="w-100 mat-height40 mat-input-style">
                          <input matInput type="number" [disabled]="!editFlagForConfirm"
                            style="color: black !important;" [(ngModel)]="noOfDaysConfirmation" placeholder="Type here"
                            class="font_regular" min="0" (keypress)="validateMaxDays($event)">

                        </mat-form-field>
                      </ion-col>
                      <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4" class="mt-20">


                        <div class="d-flex mt-15">
                          <!-- Show checkmark icon when probationId is null -->
                          <img class="ml-5 cp imgEdit" *ngIf="probationSetupId == null" title="Save"
                            src="./assets/icon/checkmark-16.png" style="width:20px; height:20px;"
                            (click)="saveConfirmation()" />


                          <!-- Edit Icon: Shows when probationId is not null -->
                          <img (click)="onClickEditConfirm()" *ngIf="probationSetupId !== null && !editFlagForConfirm"
                            class="ml-5 cp imgEdit" title="Edit" src="./assets/icon/edit.png" />

                          <!-- Close Icon: Shows when editing -->
                          <span (click)="onClickCloseForDays()" *ngIf="editFlagForConfirm"
                            class="material-icons close p-10 cp fs-20">close</span>

                          <!-- Check Icon: Shows when editing -->
                          <span *ngIf="editFlagForConfirm" (click)="saveConfirmation()"
                            class="material-icons link p-10 cp fs-20">check</span>
                        </div>
                      </ion-col>
                    </ion-row>


                  </div>





                </div>

              </div>


              <div class="cardBox mb-20">
                <div class="cardBoxHeading font_medium fs-14 fs_12ForMobile">
                  <ion-row class="pl-5">
                    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                      <div class="font_bold fs-14 fs_12ForMobile">Create email set up </div>
                    </ion-col>
                  </ion-row>
                </div>
                <div class="p-10">
                  <ion-row>
                    <!--Employment application invite email set up   -->
                    <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                      <div class="fs-14 fs_12ForMobile font_semibold mt-20">Confirmation letter mail with no change
                      </div>
                      <div class="content-box mt-20">
                        <div><img class="w50" src="././assets/icon/mail_Icon.svg" alt="createEmailBody"></div>
                        <button class="elcm_Btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                          (click)="onClickOpenCreateSurveyPopup('Confirmation letter mail with no change')">+
                          Create</button>
                      </div>
                    </ion-col>
                    <!--Employment application invite email set up   -->
                    <!-- Intimation email from candidate set up -->
                    <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                      <div class="fs-14 fs_12ForMobile font_semibold mt-20">Confirmation letter mail with change</div>
                      <div class="content-box mt-20">
                        <div><img class="w50" src="././assets/icon/mail_Icon.svg" alt="createEmailBody"></div>
                        <button class="elcm_Btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                          (click)="onClickOpenCreateSurveyPopup('confirmation with change')">+
                          Create</button>
                      </div>
                    </ion-col>
                    <!-- Intimation email from candidate set up -->
                    <!-- Offer letter upload set up -->
                    <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                      <div class="fs-14 fs_12ForMobile font_semibold mt-20">Extention of probation letter mail</div>
                      <div class="content-box mt-20">
                        <div><img class="w50" src="././assets/icon/mail_Icon.svg" alt="createEmailBody"></div>
                        <button class="elcm_Btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                          (click)="onClickOpenCreateSurveyPopup('Extention of probation letter mail')">+
                          Create</button>
                      </div>
                    </ion-col>
                    <!-- Offer letter upload set up -->

                  </ion-row>
                </div>
              </div>


              <div class="cardBox mb-20">
                <div class="cardBoxHeading font_medium fs-14 fs_12ForMobile">
                  <ion-row class="pl-5">
                    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                      <div class="font_bold fs-14 fs_12ForMobile"> Letter content set up</div>
                    </ion-col>
                  </ion-row>
                </div>
                <div class="p-10">
                  <ion-row>


                    <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                      <div class="fs-14 fs_12ForMobile font_semibold mt-20">Confirmation letter content with no change
                      </div>
                      <div class="content-box mt-20">
                        <div><img class="w70" src="././assets/icon/content-icon.jpg" alt="createEmailBody"></div>
                        <button class="elcm_Btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                          (click)="onClickOpenCreateSurveyPopup('Confirmation letter content with no change')">+
                          Create</button>
                      </div>
                    </ion-col>
                    <!-- Offer letter upload set up -->
                    <!-- Appoinment letter issuance email setup  -->
                    <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                      <div class="fs-14 fs_12ForMobile font_semibold mt-20">Confirmation letter content with change
                      </div>
                      <div class="content-box mt-20">
                        <div><img class="w70" src="././assets/icon/content-icon.jpg" alt="createEmailBody"></div>
                        <button class="elcm_Btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                          (click)="onClickOpenCreateSurveyPopup('Confirmation letter content with change')">+
                          Create</button>
                      </div>
                    </ion-col>
                    <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                      <div class="fs-14 fs_12ForMobile font_semibold mt-20">Extention of probation letter content </div>
                      <div class="content-box mt-20">
                        <div><img class="w70" src="././assets/icon/content-icon.jpg" alt="createEmailBody"></div>
                        <button class="elcm_Btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                          (click)="onClickOpenCreateSurveyPopup('Extention of probation content')">+
                          Create</button>
                      </div>
                    </ion-col>
                  </ion-row>
                </div>
              </div>




              <ion-row>
                <ion-col>
                  <div class="verticle-center" (click)="onClickback()">
                    <button class="nineBox_Btn_two fs-14 fs_12ForMobile center-content mt-20">Back</button>
                    <!-- <button class="nineBox_Btn fs-14 fs_12ForMobile center-content mt-20 ml-20"
                      [style.background-color]="buttonColorName">Save</button> -->
                  </div>
                </ion-col>
              </ion-row>
            </div>

            <!-- ------------------------------------------------------------------- probation and confirmation set up ----------------------------------------------------->

            <!-- ------------------------------------------------------------------- Exit set up ----------------------------------------------------->

            <div *ngIf="selectedTypeTabNameForSetUp=='exitsetup'">


              <div class="cardBox mb-20">

                <div class="cardBox mb-20">
                  <div class="cardBoxHeading font_medium fs-14 fs_12ForMobile">
                    <ion-row class="pl-5">
                      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                        <!-- <div class="font_bold fs-14 fs_12ForMobile">Offer letter upload set up </div> -->
                        <div class="font_bold fs-14 fs_12ForMobile">Resignation intimation<span
                            class="red-cl">&nbsp;*</span>
                        </div>
                      </ion-col>
                    </ion-row>
                  </div>
                  <div class="p-10">

                    <div style="padding: 0px 8px 8px 8px;">

                      <ion-row>
                        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                          <mat-radio-group [(ngModel)]="selectedOptionForExit" aria-label="Select an option"
                            class="fs-14 fs_12ForMobile font_semibold"
                            (change)="onSelectionChangeConfirmationExit($event.value)" [disabled]="checkassign.length>0"
                            style="color: black !important;">
                            <mat-radio-button value="MANAGER_AND_HR" class="radio-spacing">
                              Manager & HR
                            </mat-radio-button>
                            <mat-radio-button value="HOD_AND_HR" class="radio-spacing">
                              HOD & HR
                            </mat-radio-button>
                            <mat-radio-button value="HOD_AND_MANAGER_AND_HR" class="radio-spacing">
                              HOD,Manager & HR
                            </mat-radio-button>
                          </mat-radio-group>
                        </ion-col>

                      </ion-row>


                    </div>





                  </div>

                </div>
              </div>


              <ion-row>

                <ion-col size="6">

                  <div class="cardBox mb-20">
                    <div class="cardBoxHeading font_medium fs-14 fs_12ForMobile">
                      <ion-row class="pl-5">
                        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                          <!-- <div class="font_bold fs-14 fs_12ForMobile">Offer letter upload set up </div> -->
                          <div class="font_bold fs-14 fs_12ForMobile">Add Questions<span class="red-cl">&nbsp;*</span>
                          </div>
                        </ion-col>
                      </ion-row>
                    </div>
                    <div class="p-10">

                      <div style="padding: 0px 8px 8px 8px;">

                        <ion-row>
                          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">

                            <button class="elcm_Btn fs-14 fs_12ForMobile ml-10"
                              [style.background-color]="buttonColorName"
                              (click)="addPerformanceRatingStandard('addExit')">+
                              Questions</button>
                          </ion-col>

                        </ion-row>


                      </div>





                    </div>

                  </div>
                </ion-col>

                <ion-col size="6">
                  <div class="cardBox mb-20" size="6">
                    <div class="cardBoxHeading font_medium fs-14 fs_12ForMobile">
                      <ion-row class="pl-5">
                        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                          <!-- <div class="font_bold fs-14 fs_12ForMobile">Offer letter upload set up </div> -->
                          <div class="font_bold fs-14 fs_12ForMobile">View No Due Form<span
                              class="red-cl">&nbsp;*</span>
                          </div>
                        </ion-col>
                      </ion-row>
                    </div>
                    <div class="p-10">

                      <div style="padding: 0px 8px 8px 8px;">

                        <ion-row>
                          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                            <button class="elcm_Btn fs-14 fs_12ForMobile m-10"
                              [style.background-color]="buttonColorName" (click)="noDueForm(null)">View Form</button>

                          </ion-col>

                        </ion-row>


                      </div>





                    </div>

                  </div>
                </ion-col>




              </ion-row>

              <div class="cardBox mb-20  exit">

                <div class="cardBox mb-20">
                  <div class="cardBoxHeading font_medium fs-14 fs_12ForMobile">
                    <ion-row class="pl-5">
                      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                        <!-- <div class="font_bold fs-14 fs_12ForMobile">Offer letter upload set up </div> -->
                        <div class="font_bold fs-14 fs_12ForMobile">Notice Period Months<span
                            class="red-cl">&nbsp;*</span>
                        </div>
                      </ion-col>
                    </ion-row>
                  </div>
                  <div class="card">
                    <div class="table-container">
                      <ion-row class="p-5 mt-5">
                        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">

                          <table class="custom-table mat-elevation-z1 tableAccrossYear">
                            <tr>
                              <th>Band</th>
                              <th>Grade</th>
                              <th>During Probation </th>
                              <th>Confirm</th>

                            </tr>
                            <ng-container *ngFor="let item of probstionPriodsDataForExit; let i = index">
                              <tr *ngFor="let gradeItem of item.grades; let j = index">
                                <td *ngIf="j === 0" [attr.rowspan]="item.grades.length">{{ item.band }}</td>
                                <td>{{ gradeItem.grade }}</td>
                                <td>


                                  <!-- custom-radio-group.component.html -->
                                  <mat-radio-group class="custom-radio-group" [(ngModel)]="gradeItem.probationDuration"
                                    (ngModelChange)="addprobationPeriodsforExit(item,gradeItem)">
                                    <mat-radio-button *ngFor="let option of options" class="custom-radio"
                                      [value]="option">

                                      <span class="radio-label" [ngStyle]="{
                                      'color': gradeItem.probationDuration==option  ? 'white' : 'black',
                                     
                                    }">
                                        {{ option }}
                                      </span>
                                    </mat-radio-button>

                                  </mat-radio-group>
                                </td>
                                <td>

                                  <mat-radio-group class="custom-radio-group"
                                    [(ngModel)]="gradeItem.probationConfirmation"
                                    (ngModelChange)="addprobationPeriodsforExit(item,gradeItem)">
                                    <mat-radio-button *ngFor="let option of optionsforExtend" class="custom-radio"
                                      [value]="option">

                                      <span class="radio-label" [ngStyle]="{
                                      'color': gradeItem.probationConfirmation==option  ? 'white' : 'black',
                                     
                                    }">
                                        {{ option }}
                                      </span>
                                    </mat-radio-button>

                                  </mat-radio-group>

                                </td>

                              </tr>
                            </ng-container>
                          </table>



                        </ion-col>
                      </ion-row>
                    </div>



                  </div>

                </div>

              </div>

              <div class="cardBox mb-20">
                <div class="cardBoxHeading font_medium fs-14 fs_12ForMobile">
                  <ion-row class="pl-5">
                    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                      <div class="font_bold fs-14 fs_12ForMobile">Create email set up </div>
                    </ion-col>
                  </ion-row>
                </div>
                <div class="p-10">
                  <ion-row>

                    <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                      <div class="fs-14 fs_12ForMobile font_semibold mt-20">Relieving/Experience mail </div>
                      <div class="content-box mt-20">
                        <div><img class="w50" src="././assets/icon/mail_Icon.svg" alt="createEmailBody"></div>
                        <button class="elcm_Btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                          (click)="onClickOpenCreateSurveyPopup('Create Email Body Reliving/Experience mail')">+
                          Create</button>
                      </div>
                    </ion-col>

                    <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                      <div class="fs-14 fs_12ForMobile font_semibold mt-20">Relieving/Experience letter content</div>
                      <div class="content-box mt-20">
                        <div><img class="w70" src="././assets/icon/content-icon.jpg" alt="createEmailBody"></div>
                        <button class="elcm_Btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                          [style.background-color]="buttonColorName"
                          (click)="onClickOpenCreateSurveyPopup('Reliving/Experience letter content')">+
                          Create</button>
                      </div>
                    </ion-col>

                    <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                      <div class="fs-14 fs_12ForMobile font_semibold mt-20">Termination mail </div>
                      <div class="content-box mt-20">
                        <div><img class="w50" src="././assets/icon/mail_Icon.svg" alt="createEmailBody"></div>
                        <button class="elcm_Btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                          (click)="onClickOpenCreateSurveyPopup('Create Email Body for Termination Mail')">+
                          Create</button>
                      </div>
                    </ion-col>

                    <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                      <div class="fs-14 fs_12ForMobile font_semibold mt-20">Termination letter content</div>
                      <div class="content-box mt-20">
                        <div><img class="w70" src="././assets/icon/content-icon.jpg" alt="createEmailBody"></div>
                        <button class="elcm_Btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                          [style.background-color]="buttonColorName"
                          (click)="onClickOpenCreateSurveyPopup('Termination letter content')">+
                          Create</button>
                      </div>
                    </ion-col>

                  </ion-row>
                </div>
              </div>

            </div>



            <!-- ------------------------------------------------------------------- Exit set up ----------------------------------------------------->


          </div>



        </div>
      </div>


    </div>







    <!------------------------------------ Start Offer and Appointment --------------------------------------------------- -->
    <div *ngIf="selectedTypeTabName=='OfferAndAppointment'" class="p-10">
      <app-offer-and-appointment [chechsetupStatus]="!getStatusFlag || flag"></app-offer-and-appointment>
    </div>
    <!------------------------------------End Offer and Appointment --------------------------------------------------- -->

    <div class="p-10" *ngIf="
    selectedTypeTabName == 'Probation' ||
    ( selectedTypeTabName == 'Probation'&&
      loggedInUserRole === 'Manager' &&
      selectedOptionForConfirmation == 'HOD' &&
      (checkLineManagerAndHod?.length || 0) > 0 &&
      (checkLineManagerAndHodForConfirm?.length || 0) > 0
    ) ||
    (
       selectedTypeTabName == 'Probation'&&
      loggedInUserRole === 'HOD' &&
      selectedOptionForConfirmation == 'LINE_MANAGER' &&
      (checkLineManagerAndHod?.length || 0) > 0 &&
      (checkLineManagerAndHodForConfirm?.length || 0) > 0
    )
  ">



      <!-- Probation -->
      <app-probation-and-confirmation [chechsetupStatus]="!getStatusFlag">
      </app-probation-and-confirmation>


    </div>
    <!-- -------------------------------------------------------------Your Probation Evaluation Form----------------------------- -->

    <div class="p-10"
      *ngIf="(checkProbationEmployee&& loggedInUserRole=='Employee' && selectedTypeTabName!=='exit'&& selectedTypeTabName!='Reports')||selectedTypeTabName=='ProbationforEmployee'">
      <button (click)="changedFromEmployee()" class="elcm_Btn fs-14 fs_12ForMobile mt-20"
        [style.background-color]="buttonColorName">
        Your Probation Evaluation Form</button>
    </div>
    <div *ngIf="(!router.url.includes('Setup'))" class="p-10">
      <div *ngIf="selectedTypeTabName=='Reports'">
        <app-elcm-report></app-elcm-report>
      </div>
    </div>

    <div *ngIf="selectedTypeTabName == 'Dashboard' && selectedTypeTabName !== 'exit'
    && !router.url.includes('Setup')&& selectedTypeTabName!=='ProbationforEmployee'
    && (
      (loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')|| 
      (loggedInUserRole == 'Manager' && selectedOptionForConfirmation == 'LINE_MANAGER') || 
      (loggedInUserRole == 'HOD' && selectedOptionForConfirmation == 'HOD')
    )" class="p-10">

      <app-elcm-dashboard [CheckArrayLength1]="checkLineManagerAndHod" [yearArray]="pmsYears"
        [getProbationEmployeeData]="passDataForDashBoard" [chechsetupStatus]="statusFlag"
        [CheckArrayLength2]="checkLineManagerAndHodForConfirm"></app-elcm-dashboard>
    </div>

    <ng-container *ngIf="selectedTypeTabName == 'Dashboard'  && selectedTypeTabName !== 'exit'&& selectedTypeTabName!=='ProbationforEmployee'
    && !router.url.includes('Setup')&&shouldShowContainer" class="p-10">

      <app-elcm-dashboard [CheckArrayLength1]="checkLineManagerAndHod" [yearArray]="pmsYears"
        [getProbationEmployeeData]="passDataForDashBoard" [chechsetupStatus]="statusFlag"
        [CheckArrayLength2]="checkLineManagerAndHodForConfirm"></app-elcm-dashboard>
    </ng-container>


    <ng-container
      *ngIf="selectedTypeTabName == 'Dashboard'  
    && !router.url.includes('Setup')&&  (loggedInUserRole === 'Manager' && selectedOptionForConfirmation === 'HOD') ||
    (loggedInUserRole === 'HOD' && selectedOptionForConfirmation === 'LINE_MANAGER')&&
    ((checkLineManagerAndHod?.length || 0) === 0 && (checkLineManagerAndHodForConfirm?.length || 0) === 0) && !(loggedInUserRole=='Manager'&&selectedOptionForConfirmation === 'HOD'&& selectedOptionForExit=='HOD_AND_HR')">

      <div
        *ngIf="selectedTypeTabName !== 'exit' && selectedTypeTabName!='Reports'&& selectedTypeTabName!=='ProbationforEmployee'"
        class="p-10">

        <app-elcm-dashboard [CheckArrayLength1]="0" [CheckArrayLength2]="0" [yearArray]="pmsYears"
          [getProbationEmployeeData]="passDataForDashBoard" [chechsetupStatus]="statusFlag"></app-elcm-dashboard>
      </div>
    </ng-container>
  </div>
  <!-- <div>

    <ng-container *ngIf="
      selectedTypeTabName === 'exit' &&
      !router.url.includes('Setup') &&
      selectedTypeTabName !== 'Reports' &&
      selectedTypeTabName !== 'Probation' &&selectedTypeTabName !== 'Dashboard' &&
      (



      
        (loggedInUserRole === 'HR Admin' ||
        loggedInUserRole === 'Admin' ||
        loggedInUserRole === 'Super Admin' ||
        loggedInUserRole === 'PHI Admin' ||
        loggedInUserRole === 'MD') ||
        (loggedInUserRole === 'Manager' && selectedOptionForConfirmation === 'LINE_MANAGER') ||
        (loggedInUserRole === 'HOD' && selectedOptionForConfirmation === 'HOD')
      
      ) ||
      (
        (checkLineManagerAndHod?.length> 0)  &&
        (checkLineManagerAndHodForConfirm?.length > 0
        ) 
      ) 
    ">
   
      <app-elcm-exit></app-elcm-exit>
    </ng-container>
  </div>
  
  <div>
    
   
    <ng-container *ngIf="
    (
      !router.url.includes('Setup') ||
     
      selectedTypeTabName === 'exit'
    ) && selectedTypeTabName != 'Reports' &&
    selectedTypeTabName != 'Probation'&& selectedTypeTabName !== 'Dashboard' &&
    (
      (loggedInUserRole === 'Manager' && selectedOptionForConfirmation === 'HOD') ||
      (loggedInUserRole === 'HOD' && selectedOptionForConfirmation === 'LINE_MANAGER')
    ) &&
    (
      (checkLineManagerAndHod?.length || 0) === 0 &&
      (checkLineManagerAndHodForConfirm?.length || 0) === 0
    ) &&
    (
      loggedInUserRole !== 'HR Admin' &&
      loggedInUserRole !== 'Admin' &&
      loggedInUserRole !== 'Super Admin' &&
      loggedInUserRole !== 'PHI Admin' &&
      loggedInUserRole !== 'MD'
    )
  ">
 
    <app-elcm-exit></app-elcm-exit>
  </ng-container>
  
  </div> -->
  <!-- 
  <ng-container *ngIf="
  (
    !router.url.includes('Setup') || selectedTypeTabName === 'exit'
  ) &&
  selectedTypeTabName !== 'Reports' &&
  selectedTypeTabName !== 'Probation' &&  selectedTypeTabName !== 'Dashboard' &&
  (
    (loggedInUserRole === 'Manager' || loggedInUserRole === 'HOD') ||
    (loggedInUserRole === 'HOD' && selectedOptionForConfirmation === 'LINE_MANAGER')
  ) &&
  (
    (checkLineManagerAndHod?.length > 0) ||
    (checkLineManagerAndHodForConfirm?.length > 0)
  ) &&
  loggedInUserRole !== 'HR Admin' &&
  loggedInUserRole !== 'Admin' &&
  loggedInUserRole !== 'Super Admin' &&
  loggedInUserRole !== 'PHI Admin' &&
  loggedInUserRole !== 'MD'
">

  <app-elcm-exit></app-elcm-exit>
</ng-container> -->

  <ng-container *ngIf="
(
  !router.url.includes('Setup') || selectedTypeTabName === 'exit'
) &&
selectedTypeTabName !== 'Reports' && selectedTypeTabName!=='ProbationforEmployee'&&
selectedTypeTabName !== 'Probation' &&  selectedTypeTabName !== 'Dashboard' && selectedTypeTabName !== 'OfferAndAppointment'&&loggedInUserRole !=='Employee' 
" class="p-10">

    <app-elcm-exit
      [chechsetupStatus]="checkExitsetupcompletedornot?.length>0 ||selectedOptionForExit==null ||selectedOptionForExit==''"></app-elcm-exit>
  </ng-container>

  <ng-container *ngIf="
(
  !router.url.includes('Setup') &&selectedTypeTabName!=='ProbationforEmployee'&& (loggedInUserRole=='Employee'&& (checkProbationEmployee==0|| selectedTypeTabName === 'exit') )&& selectedTypeTabName!='Reports')
" class="p-10">

    <app-elcm-exit
      [chechsetupStatus]="checkExitsetupcompletedornot?.length>0 ||selectedOptionForExit==null ||selectedOptionForExit==''"></app-elcm-exit>
  </ng-container>
</ion-content>